import { useFetch } from "../../hooks/useFetch";
import api, { money } from "../../lib/api";
import { Loading, EmptyState } from "../../components/States";
import { PageHeader } from "../../components/PageHeader";
import { StatusPill } from "../../components/StageBar";
import { toast } from "sonner";
import { FileSignature, Check } from "lucide-react";

export default function BuilderChangeOrders() {
  const { data, loading, refetch } = useFetch("/change-orders");
  if (loading) return <Loading />;

  const approve = async (id) => {
    try {
      await api.post(`/change-orders/${id}/approve`);
      toast.success("Change order approved — now billable");
      refetch();
    } catch { toast.error("Could not approve"); }
  };

  const list = data || [];
  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Billable Scope Changes" title="Change Orders" subtitle="Review and electronically approve field change requests." />
      {list.length === 0 ? (
        <EmptyState title="No change orders" subtitle="Field change requests will appear here." icon={FileSignature} />
      ) : (
        <div className="space-y-3">
          {list.map((c) => (
            <div key={c.id} className="hw-card p-5 hw-rise" data-testid={`b-co-${c.id}`}>
              <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-mono2 text-xs text-cyan-400">{c.number}</span>
                    <span className="text-sm text-slate-400">· {c.lot_label}</span>
                  </div>
                  <div className="mt-1 font-semibold text-white">{c.description}</div>
                  <div className="mt-1 text-sm text-slate-500">Requested by {c.created_by}</div>
                </div>
                <div className="flex items-center gap-4">
                  <span className="font-head text-2xl font-bold text-cyan-400">{money(c.amount)}</span>
                  {c.status === "pending" ? (
                    <button onClick={() => approve(c.id)} className="flex items-center gap-2 rounded-xl bg-emerald-500 px-5 py-2.5 font-semibold text-slate-900 hover:bg-emerald-400" data-testid={`approve-co-${c.id}`}>
                      <Check size={16} /> Approve
                    </button>
                  ) : (
                    <StatusPill status={c.status} />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
